import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Anexo } from '../models/anexo.model';
import { Page } from '../models/page.model';

@Injectable({
    providedIn: 'root'
})
export class AnexoService extends BaseService<Anexo> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/anexo`, injector);
    }

    upload(arquivo: FormData): Observable<any> {
        return this.http.post(`${environment.API_PRICE}/anexo/upload`, arquivo);
    }

    getByEstimativaId(estimativaId: number): Observable<Page<Anexo>> {
        return this.http.get<Page<Anexo>>(`${environment.API_PRICE}/anexo/getByEstimativaId/${estimativaId}`);
    }

    excluirArquivo(id: number): Observable<any> {
        return this.http.get(`${environment.API_PRICE}/anexo/excluirArquivo/${id}`);
    }

    download(id: number): Observable<Blob> {
        return this.http.get(`${environment.API_PRICE}/anexo/download/${id}`, { responseType: 'blob' });
    }
}
